$(document).ready(function() {
  // Initialize the main product image slider
  var $mainSlider = $('.main_product_images_block').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: '<span class="prev_arrow arrows"> <svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></span>',
    nextArrow: '<span class="next_arrow arrows"> <svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></span>',
    asNavFor: '.thumb_product_images_block'
  });

  // Initialize the thumbnail slider
  var $thumbSlider = $('.thumb_product_images_block').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    infinite: false,
    asNavFor: '.main_product_images_block',
    dots: false,
    arrows: false
  });

  // Sync the active class with the current slide
  function updateActiveThumbnail(currentSlide) {
    var $thumbnails = $('.thumb_product_images_block .slick-slide');
    $thumbnails.removeClass('active-slide');
    var $currentThumb = $thumbnails.eq(currentSlide);
    $currentThumb.addClass('active-slide');
  }

  $mainSlider.on('afterChange', function(event, slick, currentSlide) {
    updateActiveThumbnail(currentSlide);
  });

  $thumbSlider.on('afterChange', function(event, slick, currentSlide) {
    updateActiveThumbnail(currentSlide);
  });

  // Set initial active slide class
  var initialSlideIndex = $mainSlider.slick('slickCurrentSlide');
  updateActiveThumbnail(initialSlideIndex);

  // Add click event to thumbnails
  $('.thumb_product_images_block').on('click', '.slick-slide', function() {
    var index = $(this).data('slick-index');
    $mainSlider.slick('slickGoTo', index);
    updateActiveThumbnail(index);
  });
});
